import React from "react";

// Components
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

function CheckboxWithState({
  onChange,
  value,
  label = "Check",
  readOnly = false,
  ...rest
}) {
  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  return (
    <FormControlLabel
      {...rest}
      control={
        <Checkbox checked={value} onChange={handleChange} disabled={readOnly} />
      }
      label={label}
    />
  );
}
export default CheckboxWithState;
